// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"598":"e1565bf8","703":"c52d1994"}[chunkId] + ".chunk.js";
};